<template>
  <el-form v-loading="fetchLoading" class="c-boss-sale-order-detail" label-position="top">
    <!-- 基本信息 -->
    <c-info-card id="basicInfo" class="basic-info" title="基本信息">
      <c-form-items :showOperation="false" :items="BasicInfoFormItems" :model="detailData" />
    </c-info-card>
    <!-- 商品信息 -->
    <c-info-card id="basicInfo" class="basic-info" title="商品信息">
      <c-form-items :showOperation="false" :items="ProductInfoFormItems" :model="detailData" />
    </c-info-card>
    <!-- 运单信息 -->
    <c-info-card id="basicInfo" class="basic-info" title="运单信息">
      <c-form-items :showOperation="false" :items="BillInfoFormItems" :model="detailData" />
    </c-info-card>
    <!-- 支付信息 -->
    <c-info-card id="basicInfo" class="basic-info" title="支付信息">
      <c-form-items :showOperation="false" :items="PayInfoFormItems" :model="detailData" />
    </c-info-card>
    <!-- 退款单信息 非未退款展示退款信息-->
    <c-info-card
      v-if="detailData.refundOrderStatus && RefundStatus.WAIT_REFUND !== detailData.refundOrderStatus"
      id="refundInfo"
      class="basic-info"
      title="退款信息"
    >
      <c-form-items :showOperation="false" :items="RefundInfoFormItems" :model="refundDetail" />
    </c-info-card>
  </el-form>
</template>

<script setup lang="ts">
import {
  _,
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  useApiRequest,
  useCurrentAppInstance,
  PageContext
} from '@zto/zpage'
import {
  BasicInfoFormItems,
  ProductInfoFormItems,
  BillInfoFormItems,
  PayInfoFormItems,
  RefundInfoFormItems
} from './config'
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import { OrderStatus, RefundStatus } from '@/config/enums'

const apiRequest = useApiRequest()
const app = useCurrentAppInstance()
const route = app.useRoute()
const orderCode = route.query['orderCode']

const fetchLoading = ref<boolean>(false)
const detailData = ref<any>({})

// 详情接口请求&逻辑
const getDetailData = async () => {
  fetchLoading.value = true
  try {
    const res = await apiRequest({
      action: '/cabinet/admin/oms/AdminOmsOrderQueryController/detail',
      params: {
        orderCode: orderCode
      }
    })

    detailData.value = {
      ...res?.basicInfo,
      ...res?.paymentInfo,
      ...res?.productInfo,
      productInfoData: res?.productInfo?.items || [],
      ...res?.shipmentInfo
    }

    const { refundOrderStatus } = detailData.value
    if (refundOrderStatus && RefundStatus.WAIT_REFUND !== refundOrderStatus) {
      getRefundDetailData()
    }

    fetchLoading.value = false
  } catch (error) {
    fetchLoading.value = false
  }
}

/**
 * 退款单详情
 */
const refundDetail = ref<any>({})
const getRefundDetailData = async () => {
  try {
    const res = await apiRequest({
      action: '/cabinet/admin/oms/AdminRefundFlowQueryController/latestByOrder',
      params: {
        orderCode: orderCode
      }
    })

    refundDetail.value = {
      ...(res || {})
    }
  } catch (error) {
    console.info('🚀 ~ file:CCabinetOrderDetail method:getRefundDetailData line:97 ----- error', error)
  }
}

// // 商品信息
// const ProductInfoData = ref<any>({})
// const getProductInfoData = async () => {
//   try {
//     ProductInfoData.value = await apiRequest({
//       action: 'zscm.kdg.oms.sale.queryOrderDetail',
//       params: {
//         orderCode: orderCode
//       }
//     })
//   } catch (error) {
//     console.log('error===', error)
//   }
// }

const initData = () => {
  getDetailData()
}
// 激活事件
let activeEvent: any = undefined
onMounted(() => {
  console.log('orderCode===', orderCode)
  initData()
  // 监听UI_PAGE_EVENTS.ACTIVATED（当前页激活）事件触发的回调
  activeEvent = app.ons(UI_PAGE_EVENTS.ACTIVATED, initData)
})
onBeforeUnmount(() => {
  // 解除监听UI_PAGE_EVENTS.ACTIVATED（当前页激活）事件触发的回调
  activeEvent && app.offs(activeEvent.eventTypes, activeEvent.handler)
})
</script>

<style lang="scss" scoped>
.c-boss-sale-order-detail {
  padding: 15px;
  background: #fff;

  // 字母、数字、等 换行
  .ww-bw {
    word-wrap: break-word;
  }

  .c-action {
    margin-left: 20px;
  }
}

.m-l-20 {
  margin-left: 20px;
}
</style>

<!-- 全局样式，只针对此详情 -->
<style>
.c-boss-sale-order-detail.el-form--label-top .el-form-item__label {
  padding: 0;
}

.c-boss-sale-order-detail .el-input.is-disabled .el-input__inner {
  color: inherit;
  /* cursor: default; */
}

.c-boss-sale-order-detail .el-textarea.is-disabled .el-textarea__inner {
  color: inherit;
  /* cursor: default; */
}
</style>
